import { useEffect, useState } from "react";
import Actions from "../../components/Common/Actions";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../components/Layout";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

const SustainabilityPolicy = () => {
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setLoader] = useState(true);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}sustainability-feedback/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "sustainability-feedback",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const columns = [
    {
      title: "S.No",
      key: "sno",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Feedback",
      dataIndex: "feedback",
      key: "feedback",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isDelete={true}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
        />
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          breadcrumbsList={[{ text: "Sustainability Policy", link: "" }]}
        />
      }
      addButton={<></>}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default SustainabilityPolicy;
// Compare
